export default {
  list: [
    {
      value: 'NEARBY_CAFES_MAX_DISTANCE',
      maxValue: 25,
      unit: 'KILOMETER'
    },
    {
      value: 'USER_FREE_CREDIT_AMOUNT_BY_COMPLETING_PROFILE',
      maxValue: 20000,
      currency: 'TOMAN'
    }
  ],
  values: {
    NEARBY_CAFES_MAX_DISTANCE: 'NEARBY_CAFES_MAX_DISTANCE',
    USER_FREE_CREDIT_AMOUNT_BY_COMPLETING_PROFILE: 'USER_FREE_CREDIT_AMOUNT_BY_COMPLETING_PROFILE'
  }
};
